<template>
    <AppModal ref="modal" size="lg" :title="$t('productsInAnotherIntegrationsModal.title')">
        <div class="modal-body">
            <TaskProgressBar v-if="task.state.isRunning" :done="task.state.done" :total="task.state.total"/>
            <template v-else>
                <div class="mb-3">{{ $t('productsInAnotherIntegrationsModal.message') }}</div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>{{ $t('labels.integration') }}</th>
                                <th>{{ $t('labels.publication') }}</th>
                                <th>
                                    <AppCheckbox
                                        :modelValue="allSelected"
                                        @update:modelValue="toggleSelectAll"
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in productsInAnotherIntegrations" :key="product.productUuid">
                                <td>{{ product.integrationName }}</td>
                                <td>
                                    <router-link
                                        target="_blank"
                                        :to="{name: 'Product', params: {integrationUuid: product.integrationUuid, integrationProductUuid: product.productUuid}}"
                                    >
                                        {{ product.productName }}
                                    </router-link>
                                    <br>
                                    <span class="text-muted">{{ product.productSku }}</span>
                                </td>
                                <td>
                                    <AppCheckbox
                                        v-model="product.selected"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
        <div class="modal-footer" v-if="!task.state.isRunning">
            <AppButton color="light" @click="hide">{{ $t('buttons.no') }}</AppButton>
            <AppButton color="indigo" :disabled="!hasSelectedProducts" @click="updateProducts">{{ $t('buttons.yes') }}</AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../../components/new/modal/AppModal.vue';
import AppCheckbox from '../../../../../../../components/new/form/checkbox/AppCheckbox.vue';
import AppButton from '../../../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../../../components/new/progress/TaskProgressBar.vue';

import HttpRequest from '../../../../../../../services/Http/HttpRequest';
import HttpSender from '../../../../../../../services/Http/HttpSender';
import MessageNotificator from '../../../../../../../services/MessageNotificator';
import { createProgressTask } from '../../../../../../../services/Progress/ProgressTask';

export default {
    name: 'ProductsInAnotherIntegrationsModal',
    components: {
        AppModal, AppCheckbox, AppButton, TaskProgressBar
    },
    data() {
        return {
            task: createProgressTask(),
            productsInAnotherIntegrations: [],
            request: null
        }
    },
    methods: {
        show(productsInAnotherIntegrations, request) {
            this.productsInAnotherIntegrations = productsInAnotherIntegrations.map(product => ({
                ...product,
                selected: false
            }));
            this.request = { ...request };
            delete this.request.integration_category_uuid;
            delete this.request.filter_item_uuids;
            delete this.request.source_id;
            delete this.request.second_source_id;
            this.$refs.modal.show();
        },
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.productsInAnotherIntegrations = [];
            this.request = null;
        },
        toggleSelectAll(checked) {
            this.productsInAnotherIntegrations.forEach(product => {
                product.selected = checked;
            });
        },
        async updateProducts() {
            const updateRequests = this.productsInAnotherIntegrations
                .filter(product => product.selected)
                .map(product => new HttpRequest('PATCH', `/integrations/products/${product.productUuid}`, this.request));

            const completed = await this.task.run(async ({setTotal, tick}) => {
                setTotal(updateRequests.length);

                await new HttpSender().sendRequestsInBatches(updateRequests, () => tick());
            });

            if (completed) {
                this.hide();
                new MessageNotificator().success(this.$t("alerts.success"))
            }
        }
    },
    computed: {
        allSelected() {
            return this.productsInAnotherIntegrations.length > 0 && this.productsInAnotherIntegrations.every(product => product.selected);
        },
        hasSelectedProducts() {
            return this.productsInAnotherIntegrations.some(product => product.selected);
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>